export class CompanyService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getCompanies(options) {
    return this.apiService.get('/companies', options);
  }

  getCompaniesLookup() {
    return this.apiService.get('/companies/lookup');
  }

  createCompany(data) {
    return this.apiService.post('/companies', data);
  }

  removeCompany(companyId) {
    return this.apiService.delete(`/companies/${companyId}`);
  }
}